import React, { Component } from 'react';
import { connect } from 'react-redux';
import { placeOneTimePayment } from '../modules/onetime_payment_success';
import { navigate } from '../modules/high_level_actions';
import CustomBraintreeDropin  from './CustomBraintreeDropin.jsx';
import OneTimePaymentLogin  from './OneTimePaymentLogin.jsx';

class OneTimePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      payType: 'full',
      paymentAmount: this.props.customer.balance
    }

    this.additionalParams = { amount: this.props.customer.balance };

    this.handlePayAmountChange  = this.handlePayAmountChange.bind(this);
    this.handleBlur             = this.handleBlur.bind(this);
    this.handlePayTypeChange    = this.handlePayTypeChange.bind(this);
  }

  componentWillMount() {
    if (this.props.customer.balance) {
      let nBalance = parseFloat(this.props.customer.balance).toFixed(2);
      this.setState({paymentAmount: nBalance});
      this.additionalParams = { amount: nBalance };
    }
  }

  // Flush Braintree everytime the payment page updates with new props
  componentWillReceiveProps(newProps) {
    if (this.props.customer.balance) {
      let nBalance = parseFloat(newProps.customer.balance).toFixed(2);
      this.setState({
        paymentAmount: nBalance,
        payType: 'full'
      });
      this.additionalParams = { amount: nBalance };
    }
  }

  handlePayTypeChange(evt) {
    let input = evt.currentTarget;
    let nPartialVal = 0;
    // Reset paymentAmount to full balance if full is selected
    if (input.value === 'full') {
      this.setState({
        payType: 'full',
        paymentAmount: this.props.customer.balance
      });
      this.additionalParams.amount = this.props.customer.balance;
    }
    // Get current value of partial entry field if partial is selected
    if (input.value === 'partial') {
      nPartialVal = document.getElementById('partial-pay-amount').value;
      if (parseFloat(nPartialVal).toFixed(2) > this.props.customer.balance){
        nPartialVal = self.props.customer.balance;
      }
      this.setState({
        payType: 'partial',
        paymentAmount: nPartialVal
      });
      this.additionalParams.amount = nPartialVal;
    }
  }

  handlePayAmountChange(evt) {
    let self  = this;
    let value = evt.currentTarget.value;
    // Only update if entry is a number
    if (!isNaN(value)){
      if (parseFloat(value).toFixed(2) > self.props.customer.balance){
        value = self.props.customer.balance;
      }
      self.setState({ paymentAmount: value });
      self.additionalParams.amount = value;
    }

  }

  handleBlur(evt){
    // Clean up entry on blur
    let self        = this;
    let {dispatch}  = this.props;
    let prettyValue = parseFloat(self.state.paymentAmount).toFixed(2);
    self.setState({ paymentAmount: prettyValue });
    self.additionalParams.amount = prettyValue;
  }

  render() {
    let {dispatch}   = this.props;
    let oCustomer    = this.props.customer;
    let oBody        = <OneTimePaymentLogin {...this.props} />
    let nButtonValue = 'Pay $' + parseFloat(this.state.paymentAmount).toFixed(2) + ' Now';
    let nBalance     = parseFloat(oCustomer.balance).toFixed(2)

    if (this.props.isLoggedIn && this.props.customer ) {

      let oPaymentText = (
        <div>
          <h4 className="alt2">Your balance is ${nBalance}</h4>
          <p>If you recently made a purchase, it may take up to 48 hours for it to be reflected in your account.
          <br />Please check back later or contact Customer Service for your current balance.</p>
        </div>
      );

      if( this.props.paymentSuccess === true){
        oPaymentText = (
          <div>
            <h4 className="alt2">Thank you for your payment. Your new balance is ${nBalance}</h4>
          </div>
        );
      }

      // Message if balance is $0
      if (nBalance <= 0) {
        oBody = (
          <div className="modal-body">
            <h4 className="alt2">Congratulations! Your balance is $0.00.</h4>
          </div>
        );
      }

      // Show form if balance is above $0
      if (nBalance >= 1) {
        oBody = (
          <div className="modal-body onetime-payment">
              {oPaymentText}
              <div className="bordered-box">
                <div className="half-col left">
                  <h4 className="alt">I want to pay:</h4>
                  <div className="form-otp-container">
                    <input
                      type     = "radio"
                      id       = "full-pay"
                      name     = "pay-type"
                      value    = "full"
                      checked  = {this.state.payType === 'full'}
                      onChange = {this.handlePayTypeChange}
                    />
                    <label htmlFor="full-pay">My full balance: ${nBalance}</label>
                  </div>
                  <div className="form-otp-container">
                    <input
                      type     = "radio"
                      id       = "partial-pay"
                      name     = "pay-type"
                      value    = "partial"
                      checked  = {this.state.payType === 'partial'}
                      onChange = {this.handlePayTypeChange}
                    />
                    <label htmlFor="partial-pay">Part of my balance: $</label>
                    <input
                      step         = "0.01"
                      type         = "number"
                      id           = "partial-pay-amount"
                      name         = "partial-amount"
                      value        = {this.state.paymentAmount}
                      placeholder  = {nBalance}
                      min          = "1.00"
                      max          = {nBalance}
                      onChange     = {this.handlePayAmountChange}
                      onBlur       = {this.handleBlur}
                      disabled     = {this.state.payType !== 'partial'}
                    />
                  </div>
                </div>

                <div className="half-col">
                  <h4 className="alt">Pay with:</h4>
                    <CustomBraintreeDropin
                      submitFunction = {placeOneTimePayment}
                      additionalParams = {this.additionalParams}
                      uniqueContainer = "one-time-payment-form" />
                </div>
              </div>
          </div>
        );
      }
    }

    return (
      <div className="content-max-width cms">
        <div className="content-max-width">
          <a href="/" className="button btn-secondary float-right" onClick={(evt) => this.props.dispatch(navigate(evt))}>Continue shopping</a>
          <h2>Make a Payment</h2>
        </div>
        {oBody}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'paymentSuccess': state.onetimePaymentSuccess,
      'customer': state.customer,
      'isLoggedIn': state.isLoggedIn
    };
}

export default connect(mapStateToProps)(OneTimePayment);


// WEBPACK FOOTER //
// ./src/components/OneTimePayment.jsx